/**               
 *                
 *                        ..
 *                  ___,  /' 
 *             _.-'` __|_/
 *           .'  ,-:`  |/ `'-,
 *          /  .'    .`|`'.   '.
 *         /  /     '  |  `.    \
 *        |  |     |   |   |     |
 *        |  |     |   |   |     |
 *        |  |     |   |   |     |
 *         \  \    `.  |  /     /
 *          \  `.    `'|.'   .'
 *           '._ `'-._/|__.-'`
 *              `-.__/_|
 *                  /  |
 *                _____|_____
 *               /___________\
 *             Greenwich Loyalty
 *        https://greenwichloyalty.com
 *          
**/           
import { useState, useEffect } from 'react';

import { ImSpinner5 } from "react-icons/im";
import { TbRefreshDot } from "react-icons/tb";

const Refreshing = (props) => {

  const [msg, setMsg] = useState('Loading...');

  useEffect(() => {
    if (props.hasOwnProperty('message') && props.message) {
      setMsg(props.message);
    };
  }, []);
    
  return (
    <div style={{ display : 'flex', width : '100%', alignItems : 'center', justifyContent : 'center' }}>
      <div style={{ display : 'flex', width : '100%', flexDirection : 'column', alignItems : 'center' }}>
      <TbRefreshDot size='12em' style = {{ marginTop : 0, zIndex : 10 }} color='grey' className = 'spinnerIcon' />
      <h5 style={{ zIndex : 10 }}>{ msg }</h5>
      <div style={{ marginTop : 40 }} />
      </div>
    </div>
  );

};

export default Refreshing;
